import React from "react";
import signImg from "../../../../static/images/sign.svg";
// import infoIcon from "../../../../static/images/info.svg";
// import Tooltip from "../../../secondary/Tooltip/tooltip";
import styles from "./signAndLock.module.scss";
// import { PendingTooltip } from "./SignButton";

export const SignDropdown = ({ isSign, pendingItems, viewDrop, dropRef, onToggle, onSign, onSignAndLock }) => (
  <span className={`${styles.sign_dropdown} dropdown`}>
    {/* <button className={styles.lock} onClick={onToggle} ref={dropRef} disabled={!isSign}> */}
    <button className={styles.lock} onClick={onToggle} ref={dropRef}>
      <img src={signImg} alt="sign" />
      Sign
      {/* {!isSign && (
        <Tooltip placement="right" className={styles.tooltip} content={<PendingTooltip pendingItems={pendingItems} />} width="600px">
          <img src={infoIcon} alt="info" />
        </Tooltip>
      )} */}
    </button>
    {viewDrop && (
      <span className="dropdown-menu dropdown-menu-right show" ref={dropRef}>
        <button data-testid="sign" className="dropdown-item" onClick={onSign}>
          Sign
        </button>
        <button className={`dropdown-item ${styles.sign_border_top}`} onClick={onSignAndLock}>
          Sign &amp; Lock
        </button>
      </span>
    )}
  </span>
);
